export default __webpack_public_path__ + "static/media/Search.4ec1e6f7.svg";